import React, {useState, useEffect} from 'react';
import {connect, Provider} from "react-redux";
import {getReduxStore} from "../ReduxStore/store";
import MenuBar from "./MenuBar";

function mapStateToProps(state) {
  const {navigationSlice = {}} = state;

  return navigationSlice;
}

let Wrapper = connect(mapStateToProps)(MenuBar);

export default function MenuBarApp(props) {
  return <Provider store={getReduxStore()}>
    <Wrapper {...props} />
  </Provider>
}
